module.exports = __webpack_public_path__ + "static/media/fruit-pineapple-2.3ecd5fd0.png";